import { PerceivedProvisioningStartTimer } from '../../utils/perceived-provisioning/perceived-provisioning-start-timer';
import { defaultScreenConfig } from '../../utils/screen-manager/default-screen-config';
import { defaultScreenDictionary } from '../../utils/screen-manager/default-screen-dictionary';
import { ProductRedirector } from '../product-redirector/product-redirector';
import RobotsView from '../robots/robots-view';

import { BaseProvisioningUI } from './base-provisioning-ui';

/**
 * Component that shows default provisioning UI.
 * @returns @type {JSX.Element}
 */
export const DefaultProvisioningUI = () => {
	return (
		<BaseProvisioningUI
			screenConfig={defaultScreenConfig}
			screenDictionary={defaultScreenDictionary}
			screenFallback={
				<PerceivedProvisioningStartTimer>
					<ProductRedirector>
						<RobotsView />
					</ProductRedirector>
				</PerceivedProvisioningStartTimer>
			}
		/>
	);
};
